import { render, staticRenderFns } from "./PrescriptionSuccess.vue?vue&type=template&id=4a9fc11b"
import script from "./PrescriptionSuccess.vue?vue&type=script&lang=js"
export * from "./PrescriptionSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports